import { withError } from './ErrorTemplate'

export default withError({
  code: 'Упс...',
  error: 'Что-то пошло не так',
})

// export default () => 'FUCK YOU'
